<template>
  <div class="c-steps">
    <div class="c-steps--step c-steps--step__active">
      1. Pakket gekozen
      <span class="c-steps--dot"></span>
    </div>
    <div class="c-steps--step c-steps--step__active" :class="{'current': step === 2}">
      2. Uw gegevens
      <span class="c-steps--dot"></span>
    </div>
    <div class="c-steps--step" :class="{'c-steps--step__active current': step === 3}">
      3. Bevestiging
      <span class="c-steps--dot"></span>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		step: {
			type: Number,
			default: () => 2
		}
	}
};
</script>

<style>
</style>
